import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import "chartjs-adapter-luxon";
import { DateTime } from "luxon";
import Modal from "react-bootstrap/Modal";
import DateLabels from "./DateLabels";
import { getDarkColour, getLightColour } from "./Util";
import { DecimalPlaces } from "../App";

ChartJS.register(
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  DateLabels
);

export default function PriceModal(props) {
  const graphOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: false,
      },
      tooltip: {
        mode: "index",
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            if (label) {
              label = label + ": ";
            }
            if (context.parsed.y !== null) {
              if (context.datasetIndex === 2) {
                label += DecimalPlaces(context.parsed.y, 1) + " GW";
              } else {
                label += new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(context.parsed.y);
                label += "/MW";
              }
            }
            return label;
          },
          labelColor: function (context) {
            return {
              borderColor: context.dataset.borderColor,
              backgroundColor: context.dataset.borderColor,
            };
          },
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    layout: {
      padding: {
        bottom: 20,
      },
    },
    scales: {
      x: {
        type: "time",
        adapters: {
          date: {
            zone: "Canada/Mountain",
          },
        },
        time: {
          unit: "day",
          displayFormats: {
            hour: DateTime.DATE_SHORT,
          },
          tooltipFormat: DateTime.DATETIME_FULL,
        },
        grid: {
          offset: false,
        },
        ticks: {
          callback: (label) => "",
        },
      },
      yPrice: {
        ticks: {
          callback: (label) => `$${label}`,
        },
      },
      yDemand: {
        beginAtZero: true,
        position: "right",
        ticks: {
          crossAlign: "near",
          callback: (label) => `${DecimalPlaces(label, 1)} GW`,
          count: (context) => {
            return context.chart.scales.yPrice.ticks.length;
          },
        },
      },
    },
  };

  let graphData = {
    datasets: [
      {
        label: "Price",
        data: props.priceData,
        borderColor: getDarkColour(),
        pointRadius: 0,
        backgroundColor: "white",
        cubicInterpolationMode: "monotone",
        fill: false,
        order: 0,
        yAxisID: "yPrice",
      },
      {
        label: "30-Day Rolling Average",
        data: props.priceAverageData,
        borderColor: getLightColour(),
        pointRadius: 0,
        backgroundColor: "white",
        cubicInterpolationMode: "monotone",
        fill: false,
        order: 1,
        yAxisID: "yPrice",
      },
      {
        label: "Demand",
        data: props.demand,
        borderColor: "grey",
        pointRadius: 0,
        backgroundColor: "white",
        cubicInterpolationMode: "monotone",
        fill: false,
        order: 2,
        yAxisID: "yDemand",
        borderDash: [10, 5],
      },
    ],
  };

  return (
    <Modal
      show={props.show}
      onHide={props.close}
      dialogClassName="historyModal"
      centered
    >
      <Modal.Header style={{ backgroundColor: getLightColour() }} closeButton>
        <Modal.Title>Pool Price History</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: props.height + "px" }}>
        <Line options={graphOptions} data={graphData} />
      </Modal.Body>
    </Modal>
  );
}
